/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdDomainSettingsAdvertisementFbInstantInterstitialOptions interface.
 */
export function instanceOfFxIdDomainSettingsAdvertisementFbInstantInterstitialOptions(value) {
    if (!('DefaultPlacementId' in value) || value['DefaultPlacementId'] === undefined)
        return false;
    return true;
}
export function FxIdDomainSettingsAdvertisementFbInstantInterstitialOptionsFromJSON(json) {
    return FxIdDomainSettingsAdvertisementFbInstantInterstitialOptionsFromJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementFbInstantInterstitialOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'DefaultPlacementId': json['DefaultPlacementId'],
    };
}
export function FxIdDomainSettingsAdvertisementFbInstantInterstitialOptionsToJSON(json) {
    return FxIdDomainSettingsAdvertisementFbInstantInterstitialOptionsToJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementFbInstantInterstitialOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'DefaultPlacementId': value['DefaultPlacementId'],
    };
}
//# sourceMappingURL=FxIdDomainSettingsAdvertisementFbInstantInterstitialOptions.js.map